import React from 'react';
import block from 'bem-cn-lite';

import RecommendedIcon from 'components/RecommendedIcon/RecommendedIcon';

import './NavigationMenu.scss';

const b = block('navigation-menu');

export interface NavigationMenuItem {
    id: string;
    title: string;
    isFeatured?: boolean;
}

export interface NavigationMenuProps {
    items: NavigationMenuItem[];
    active: string;
    onChange: (category: string) => void;
    className?: string;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({items, active, onChange, className}) => {
    return (
        <menu className={b(null, className)}>
            <ul className={b('sections')}>
                {items.map(({id, title, isFeatured}) => (
                    <li
                        key={id}
                        className={b('section', {active: id === active})}
                        onClick={() => onChange(id)}
                    >
                        <span className={b('section-link')}>
                            {title}
                            {isFeatured ? (
                                <RecommendedIcon className={b('icon')} size={16} />
                            ) : null}
                        </span>
                    </li>
                ))}
            </ul>
        </menu>
    );
};

export default NavigationMenu;
